import React from "react";
import axios from "axios";
import SummaryApi from "../common/SummaryApi";
import { toast } from "react-hot-toast";

import { MapPin, Mail, Clock3  } from "lucide-react";
import { LuPhoneCall } from "react-icons/lu";
const ContactUs = () => {
    const [formData, setFormData] = React.useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    subject: "",
    });

    const [loading, setLoading] = React.useState(false);

        const handleSubmit = async (e) => {
    e.preventDefault();

    if (
        !formData.firstName ||
        !formData.lastName ||
        !formData.email ||
        !formData.phone ||
        !formData.subject
    ) {
        toast.error("Please fill all fields");
        return;
    }

    try {
        setLoading(true);

        const res = await axios({
        url: SummaryApi.submitContact.url,
        method: SummaryApi.submitContact.method,
        data: formData,
        });

        if (res.data.success) {
        toast.success("Message sent successfully");

        setFormData({
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            subject: "",
        });
        } else {
        toast.error("Something went wrong");
        }
    } catch (err) {
        toast.error(
        err?.response?.data?.message || "Failed to send message"
        );
    } finally {
        setLoading(false);
    }
    };

    const handleChange = (e) => {
    setFormData({
        ...formData,
        [e.target.name]: e.target.value,
    });
    };


  return (
    <div className="">
      {/* PAGE TITLE */}
      <div className="bg-white py-2 shadow-[0_0_20px_rgba(0,0,0,0.05)] mb-2">
      <h1 className="text-center text-lg font-medium">
        Contact US
      </h1>
      </div>

      {/* MAIN CARD */}
      <div className="container mx-auto rounded-xl shadow-sm p-6 md:p-10">

        {/* GRID */}
        <div className="grid grid-cols-1 lg:grid-cols-[320px_1fr] gap-8">

          {/* ================= LEFT INFO ================= */}
          <div className="bg-white rounded-xl p-6 space-y-6 shadow-[0_0_20px_rgba(0,0,0,0.02)]">
            <div className="flex flex-col items-center text-center space-y-2">
              <MapPin size={36} strokeWidth={1.5} className="text-[#007BFF]" />
              <p className="text-sm text-[#333333]">
                RTEX Retail Clothing Store <br />
                Main Market Road, <br />
                Pattukkottai, Tamil Nadu - 600040
              </p>
            </div>

            <hr className="border-0.5 border-[#E6E6E6]"/>

            <div className="flex flex-col items-center text-center space-y-2">
              <Mail size={36} strokeWidth={1.5} className="text-[#007BFF]" />
              <a
                href="mailto:rtexiles1985@gmail.com"
                className="text-sm text-[#333333]"
              >
                rtexiles1985@gmail.com
              </a>
            </div>

            <hr className="border-0.5 border-[#E6E6E6]"/>

            <div className="flex flex-col items-center text-center space-y-2">
              <LuPhoneCall size={36} strokeWidth={1.5} className="text-[#007BFF]" />
              <a href="tel:+917010087910" className="text-sm text-[#333333]">+91 70100 87910</a>
            </div>

            <hr className="border-0.5 border-[#E6E6E6]"/>

            <div className="flex flex-col items-center text-center space-y-2">
              <Clock3  size={36} strokeWidth={1.5} className="text-[#007BFF]" />
              <p className="text-sm text-[#333333]">
                9am to 9pm
              </p>
            </div>
          </div>

          {/* ================= RIGHT FORM ================= */}
          <div className="bg-white rounded-xl shadow-[0_0_20px_rgba(0,0,0,0.02)] p-6 md:p-8">
            <h2 className="text-lg font-semibold mb-1">
              Just Say Hello!
            </h2>

            <p className="text-sm text-[#808080] mb-6">
                Any question or remarks? Just write us a message!
            </p>

            {/* FORM */}
            <form className="space-y-4" onSubmit={handleSubmit}>
              {/* NAME */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="First Name"
                className="w-full border border-[#E6E6E6] rounded-md px-4 py-3 text-sm focus:outline-none focus:border-[#007BFF]"
                />

                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Last Name"
                  className="w-full border border-[#E6E6E6] rounded-md px-4 py-3 text-sm focus:outline-none focus:border-[#007BFF]"
                />
              </div>

              {/* EMAIL + PHONE */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email Address"
                  className="w-full border border-[#E6E6E6] rounded-md px-4 py-3 text-sm focus:outline-none focus:border-[#007BFF]"
                />
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Phone Number"
                  className="w-full border border-[#E6E6E6] rounded-md px-4 py-3 text-sm focus:outline-none focus:border-[#007BFF]"
                />
              </div>

              {/* SUBJECT */}
              <textarea
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="Subjects"
                rows={5}
                className="w-full border border-[#E6E6E6] rounded-md px-4 py-3 text-sm focus:outline-none focus:border-[#007BFF] resize-none"
              />

              {/* BUTTON */}
                <button
                type="submit"
                disabled={loading}
                className="bg-[#007BFF] hover:bg-[#036ee0] disabled:opacity-60 text-white text-sm font-semibold px-8 py-3 rounded-full transition"
                >
                {loading ? "Sending..." : "Send Message"}
                </button>
            </form>
          </div>
        </div>

        {/* ================= MAP ================= */}
        <div className="mt-10 rounded-xl overflow-hidden border">
          {/* <iframe
            title="map"
            src="https://www.google.com/maps?q=Pattukkottai%20Tamil%20Nadu&output=embed"
            className="w-full h-[400px] border-0"
            loading="lazy"
          /> */}

          <iframe title="RegeesTex" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3923.956423833371!2d79.31422587583585!3d10.425032765575324!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b00014231b1eda3%3A0x2dfe4ac12ca5963!2sR%20Tex%20pattukkottai!5e0!3m2!1sen!2sin!4v1768290169386!5m2!1sen!2sin" className="w-full h-[400px] border-0" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
